/**
 * 文字数チェック用
 */
// 最小文字数
// パスワード・家族/企業パスワード
export const minLengthOfPassword = 8;
// 最大文字数
// 認証コード
export const maxLengthOfAuthenticationCode = 6;
// 企業ID
export const maxLengthOfCompanyId = 32;
// ユーザーID
export const maxLengthOfUserId = 20;
// パスワード・家族/企業パスワード
export const maxLengthOfPassword = 25;
// メールアドレス
export const maxLengthOfMailAddress = 254;
// 電話番号
export const maxLengthOfTelNumber = 20;
// 短文文字列。姓・名・続柄など
export const maxLengthOfShortString = 64;
// 文字列。問診・アンケート項目など
export const maxLengthOfString = 128;
// 長文文字列。連絡メッセージなど
export const maxLengthOfLongString = 2000;
// 表示順や整数値などの数値項目（int32）
export const minLengthOfDisplayOrderString = -2147483648;
export const maxLengthOfDisplayOrderNumber = 2147483647;

/**
 * 入力不正チェック用
 */
// パスワードで許容する記号。! " # $ % & ' ( ) * + - . , / : ; < = > ? @ [ ] \ ^ _ ` { | } ~
const passwordPolicySymbols = '\\!\\"\\#\\$\\%\\&\\\'\\(\\)\\*\\+\\-\\.\\,\\/\\:\\;\\<\\=\\>\\?\\@\\[\\]\\\\\\^\\_\\`\\{\\|\\}\\~';
// 0～9の数字
export const matchPatternNumber = '^[0-9]+$';
// 半角英数字
export const matchPatternAlphabetNumber = '^[a-zA-Z0-9]+$';
// 半角英数小文字
export const matchPatternLowerAlphabetNumber = '^[a-z0-9]+$';
// 半角英数混合。英字小文字もしくは大文字1文字以上＋数字1文字以上
export const matchPatternAlphabetNumberMix = '^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$';
// 半角英数記号混合。英字小文字もしくは大文字1文字以上＋数字1文字以上＋記号1文字以上
export const matchPatternAlphabetNumberSymbol = '^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[' + passwordPolicySymbols + '])[a-zA-Z0-9' + passwordPolicySymbols + ']+$';
// 電話番号。数字1文字以上＋「-(ハイフン)」1文字以上
export const matchPatternTelNumber = '^(?=.*[0-9])(?=.*-)[0-9-]{2,}$';

// メールアドレス
export const matchPatternMailAddress = '^([\\w!#$%&\'*+/=?^_`{|}~-]+(?:\\.[\\w!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)+$';
//export const matchPatternMailAddress = '^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]+\\.[A-Za-z0-9]+$';

// 姓（セイ）・名（メイ）。全角カナ＋全角英数字＋全角記号のみ許容
export const matchPatternKana = '^[ァ-ンヴー０-９Ａ-Ｚａ-ｚ　！”＃＄％＆’（）＊＋，―．／：；＜＝＞？＠［＼］＾＿｀｛｜｝〜]+$';

export default {
    minLengthOfPassword,
    maxLengthOfCompanyId,
    maxLengthOfUserId,
    maxLengthOfPassword,
    maxLengthOfAuthenticationCode,
    maxLengthOfMailAddress,
    maxLengthOfTelNumber,
    maxLengthOfShortString,
    maxLengthOfString,
    maxLengthOfLongString,
    minLengthOfDisplayOrderString,
    maxLengthOfDisplayOrderNumber,
    matchPatternNumber,
    matchPatternAlphabetNumber,
    matchPatternLowerAlphabetNumber,
    matchPatternAlphabetNumberMix,
    matchPatternAlphabetNumberSymbol,
    matchPatternTelNumber,
    matchPatternMailAddress,
    matchPatternKana,
};
